(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[962],{

/***/ 68868:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/cart",
      function () {
        return __webpack_require__(6251);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GN": function() { return /* binding */ addToCartWithPrice; },
  "o3": function() { return /* binding */ applyCouponToCart; },
  "DU": function() { return /* binding */ createGuestEmptyCart; },
  "XM": function() { return /* binding */ getCartDataFromServer; },
  "n2": function() { return /* binding */ loggedInUserCartId; },
  "Lw": function() { return /* binding */ mergeCarts; },
  "r$": function() { return /* binding */ removeCouponFromCart; },
  "Cn": function() { return /* binding */ removeItemFromCart; },
  "xu": function() { return /* binding */ updateCart; }
});

// UNUSED EXPORTS: addToCart

// EXTERNAL MODULE: ./graphqlClient.js
var graphqlClient = __webpack_require__(33119);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(31230);
// EXTERNAL MODULE: ./gql/common.js
var common = __webpack_require__(76708);
;// CONCATENATED MODULE: ./gql/cart/cart.gql.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nquery($cartId: String!) {\n    cart(cart_id: $cartId) ",
        "\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nquery GetCartId {\n  customerCart {\n    id\n  }\n}\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nmutation CreateGuestCart {\n  createEmptyCart\n}\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddToCart($cartId: String!, $sku: String!, $quantity: Float!) {\n    addSimpleProductsToCart(\n      input: {\n        cart_id: $cartId\n        cart_items: [\n          {\n            data: {\n              quantity: $quantity\n              sku: $sku\n            }\n          }\n        ]\n      }\n    ) {\n      cart ",
        "\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation addSimpleProductsToCartCustomPrice($pincode: String!, $cartId: String!, $sku: String!, $quantity: Float!, $custom_price: Float!) {\n    addSimpleProductsToCartCustomPrice(\n      input: {\n        cart_id: $cartId\n        pincode: $pincode\n        cart_items: [\n          {\n              quantity: $quantity\n              sku: $sku\n              custom_price: $custom_price\n            \n          }\n        ]\n      }\n    )  ",
        "\n    \n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nmutation RemoveItemFromCart($cartId: String!, $cartItemId: Int!) {\n  removeItemFromCart(\n    input: {\n      cart_id: $cartId,\n      cart_item_id: $cartItemId\n    }\n  ) {\n    cart ",
        "\n  }\n}\n\n\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation MergeCarts($sourceCartId: String!, $destinationCartId: String!) {\n    mergeCarts(sourceCartId: $sourceCartId, destinationCartId: $destinationCartId) {\n      id\n      items {\n        id\n        quantity\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "mutation($cartId: String!, $couponCode: String!) {\n  applyCouponToCart(\n    input: {\n      cart_id: $cartId\n      coupon_code: $couponCode\n    }\n  ) {\n    cart",
        "\n  }\n}\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveCouponFromCart($cartId: String!) {\n    removeCouponFromCart (\n      input:{ cart_id: $cartId }\n  ) \n  {\n     cart ",
        "\n  }\n}"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ($cartId: String!, $cartItems: [CartItemUpdateInput!]!) {\n    updateCartItems(\n      input: {\n        cart_id: $cartId\n        cart_items: $cartItems\n      }\n    ) {\n      cart ",
        "\n    }\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}


const CART_DATA = (0,lib/* gql */.Ps)(_templateObject(), common/* commonCart */.WU);
// export const GUEST_MINI_CART = gql`
// query($cartId: String!) {
//     cart(cart_id: $cartId) {
//       id
//       items {
//         id
//         quantity
//         product {
//           sku
//           name
//           price {
//             regularPrice {
//               amount {
//                 value
//                 currency
//               }
//             }
//           }
//         }
//       }
//       prices {
//         grand_total {
//           value
//           currency
//         }
//       }
//     }
//   }
// `;
// export const LOGGED_IN_USER_MINI_CART = gql`
// query($cartId: String!) {
//     cart(cart_id: $cartId) {
//       id
//       items {
//         id
//         quantity
//         product {
//           sku
//           name
//           price {
//             regularPrice {
//               amount {
//                 value
//                 currency
//               }
//             }
//           }
//         }
//       }
//       prices {
//         grand_total {
//           value
//           currency
//         }
//       }
//     }
//   }
// `;
const LOGGED_IN_USER_CART_ID = (0,lib/* gql */.Ps)(_templateObject1());
const CREATE_GUEST_EMPTY_CART = (0,lib/* gql */.Ps)(_templateObject2());
const cart_gql_ADD_TO_CART = (0,lib/* gql */.Ps)(_templateObject3(), common/* commonCart */.WU);
const ADD_TO_CART_WITH_CUSTOM_PRICE = (0,lib/* gql */.Ps)(_templateObject4(), common/* commonCart */.WU);
const REMOVE_ITEM_FORM_CART = (0,lib/* gql */.Ps)(_templateObject5(), common/* commonCart */.WU);
const MERGE_CARTS = (0,lib/* gql */.Ps)(_templateObject6());
const APPLY_COUPAN_TO_CART = (0,lib/* gql */.Ps)(_templateObject7(), common/* commonCart */.WU);
const REMOVE_COUPAN_FROM_CART = (0,lib/* gql */.Ps)(_templateObject8(), common/* commonCart */.WU);
const UPDATE_CART = (0,lib/* gql */.Ps)(_templateObject9(), common/* commonCart */.WU);
;

;// CONCATENATED MODULE: ./api.services.js/cart.js


const getCartDataFromServer = async (variables)=>{
    let options = {
        query: CART_DATA,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            },
            fetchPolicy: "no-cache"
        };
    }
    try {
        const response = await graphqlClient/* default.query */.Z.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
const addToCart = async (variables)=>{
    let options = {
        mutation: ADD_TO_CART,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            },
            fetchPolicy: "no-cache"
        };
    }
    try {
        const response = await client.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const addToCartWithPrice = async (variables)=>{
    let options = {
        mutation: ADD_TO_CART_WITH_CUSTOM_PRICE,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            },
            fetchPolicy: "no-cache"
        };
    }
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const removeItemFromCart = async (variables)=>{
    let options = {
        mutation: REMOVE_ITEM_FORM_CART,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            },
            fetchPolicy: "no-cache"
        };
    }
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const createGuestEmptyCart = async (variables)=>{
    const options = {
        mutation: CREATE_GUEST_EMPTY_CART,
        variables: variables
    };
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const loggedInUserCartId = async (variables)=>{
    const options = {
        query: LOGGED_IN_USER_CART_ID,
        variables: variables,
        context: {
            headers: {
                Authorization: "Bearer ".concat(variables.token)
            }
        }
    };
    try {
        const response = await graphqlClient/* default.query */.Z.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
const mergeCarts = async (variables)=>{
    const options = {
        mutation: MERGE_CARTS,
        variables: variables,
        context: {
            headers: {
                Authorization: "Bearer ".concat(variables.token)
            }
        }
    };
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const applyCouponToCart = async (variables)=>{
    let options = {
        mutation: APPLY_COUPAN_TO_CART,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            }
        };
    }
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const removeCouponFromCart = async (variables)=>{
    let options = {
        mutation: REMOVE_COUPAN_FROM_CART,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            }
        };
    }
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const updateCart = async (variables)=>{
    let options = {
        mutation: UPDATE_CART,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            },
            fetchPolicy: "no-cache"
        };
    }
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};


/***/ }),

/***/ 76708:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
const _jsxRuntime = __webpack_require__(85893);
module.exports.WU = "{\n    id\n    pincode\n    prices {\n      grand_total {\n        value\n        currency\n      }\n      subtotal_including_tax {\n        value\n        currency\n      }\n      discount {\n        amount {\n          value\n          currency\n        }\n      }\n    }\n    items {\n      uid\n      id\n      quantity\n      prices {\n        total_item_discount {\n          value\n          currency\n        }\n        row_total {\n          value\n          currency\n        }\n        price {\n          value\n          currency\n        }\n        discounts {\n          label\n          amount {\n            value\n            currency\n          }\n        }\n      }\n      product {\n        sku\n        name\n        image {\n          url\n          label\n        }\n        price {\n          regularPrice {\n            amount {\n              value\n              currency\n            }\n          }\n        }\n      }\n    }\n   applied_coupons {\n    code\n  }\n  email\n  billing_address {\n    firstname\n    lastname\n    company\n    street\n    city\n    region{\n      code\n      label\n    }\n    postcode\n    telephone\n    country{\n      code\n      label\n    }\n  }\n  shipping_addresses {\n    firstname\n    lastname\n    company\n    street\n    city\n    region {\n      code\n      label\n    }\n    postcode\n    telephone\n    country {\n      code\n      label\n    }\n    available_shipping_methods{\n      carrier_code\n      carrier_title\n      method_code\n      method_title\n      amount {\n        value\n        currency\n      }\n    }\n      selected_shipping_method {\n        carrier_code\n        carrier_title\n        method_code\n        method_title\n        amount {\n          value\n          currency\n        }\n      }\n    }\n    available_payment_methods {\n      code\n      title\n    }\n    selected_payment_method {\n      code\n    }\n  }\n  ";
module.exports.Kn = (address)=>{
    if (!address) {
        return;
    }
    let addr = [];
    if (address.street) {
        addr.push(address.street);
    }
    if (address.city) {
        addr.push(address.city);
    }
    if (address.region) {
        addr.push(address.region.region);
    }
    if (address.postcode) {
        addr.push(address.postcode);
    }
    if (address.country_code) {
        addr.push(address.country.code);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        children: addr.join(", ")
    });
};
module.exports.LJ = (address)=>{
    if (!address) {
        return;
    }
    let addr = [];
    if (address.street) {
        addr.push(address.street);
    }
    if (address.city) {
        addr.push(address.city);
    }
    if (address.region) {
        addr.push(address.region.region);
    }
    if (address.postcode) {
        addr.push(address.postcode);
    }
    if (address.country_code) {
        addr.push(address.country.code);
    }
    return addr.join(", ");
};


/***/ }),

/***/ 33119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61680);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24145);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38067);

// // enable cors
// var corsOptions = {
//     origin: true,
//     credentials: true // <-- REQUIRED backend setting
//   };
//   app.use(cors(corsOptions));
const headers = {
    "Access-Control-Allow-Origin": "*"
};
const httpLink = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .createHttpLink */ .L)({
    uri: "http://orientbell.com/graphql"
});
const client = new _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .ApolloClient */ .f({
    //link: headers.concat(httpLink),
    uri: "https://obl-js.orientbell.com/",
    cache: new _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .InMemoryCache */ .h(),
    fetchOptions: {
        mode: "no-cors"
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (client);


/***/ }),

/***/ 6251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Table__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75147);
/* harmony import */ var react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5607);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35005);
/* harmony import */ var react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4492);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _api_services_js_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50569);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89583);
/* harmony import */ var _src_components_loader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62077);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46737);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81354);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_8__);














const Cart = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const [cartData, setCartData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [coupon, setCoupon] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        getCartData();
    }, []);
    let fireUnbxdOrder = (unxPayload)=>{
        console.log(unxPayload, "unxPayload payload");
        setTimeout(function() {
            if (window.Unbxd) {
                Unbxd.trackMultiple("order", unxPayload);
            } else {
                console.log("Unbxd is not defined");
            }
        }, 2000);
    };
    let getCartData = async ()=>{
        // decrypt token
        const token = crypto_js__WEBPACK_IMPORTED_MODULE_8__.AES.decrypt(localStorage.getItem("userToken"), "wqeetdrcgfyt6rfychgvhy78t67gvjbhu89y78tgu909iuygcvbnjmkhuyghbvnkjiougyhbvjnmkloipughbj").toString();
        if (localStorage.getItem("userToken") && !localStorage.getItem("cartId")) {
            let cartId = await (0,_api_services_js_cart__WEBPACK_IMPORTED_MODULE_4__/* .loggedInUserCartId */ .n2)({
                token
            });
            localStorage.setItem("cartId", cartId.data.customerCart.id);
            let loggedInUserCartData = await (0,_api_services_js_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartDataFromServer */ .XM)({
                cartId: cartId.data.customerCart.id,
                token
            });
            setCartData(loggedInUserCartData.data.cart);
            // fireUnbxdOrder(loggedInUserCartData.data.cart.items.map((cc)=>{
            //   return {
            //       pid: cc.product.sku,
            //       qty: cc.prices.price.value,
            //       price: cc.quantity
            //   }
            // }))
            setLoading(false);
        } else if (localStorage.getItem("userToken") && localStorage.getItem("cartId")) {
            let loggedInUserCartData1 = await (0,_api_services_js_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartDataFromServer */ .XM)({
                cartId: localStorage.getItem("cartId"),
                token
            });
            setCartData(loggedInUserCartData1.data.cart);
            // fireUnbxdOrder(loggedInUserCartData.data.cart.items.map((cc)=>{
            //   return {
            //       pid: cc.product.sku,
            //       variantId: "", // Only if variant is present
            //       qty: cc.prices.price.value,
            //       price: cc.quantity
            //   }
            // }))
            setLoading(false);
        } else if (localStorage.getItem("cartId")) {
            var ref;
            let guestCart = await (0,_api_services_js_cart__WEBPACK_IMPORTED_MODULE_4__/* .getCartDataFromServer */ .XM)({
                cartId: localStorage.getItem("cartId")
            });
            setCartData((ref = guestCart.data) === null || ref === void 0 ? void 0 : ref.cart);
            // fireUnbxdOrder(guestCart.data.cart.items.map((cc)=>{
            //   return {
            //       pid: cc.product.sku,
            //       variantId: "", // Only if variant is present
            //       qty: cc.prices.price.value,
            //       price: cc.quantity
            //   }
            // }))
            setLoading(false);
        } else {
            setLoading(false);
        }
        console.log(cartData);
    };
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const handleGoBack = ()=>{
        router.back();
    };
    const removeFromCart = async (e)=>{
        // setCartData(null);
        let obj = {
            cartId: localStorage.getItem("cartId"),
            cartItemId: e.id
        };
        if (localStorage.getItem("userToken")) {
            // decrypt token
            obj = {
                ...obj,
                token: crypto_js__WEBPACK_IMPORTED_MODULE_8__.AES.decrypt(localStorage.getItem("userToken"), "wqeetdrcgfyt6rfychgvhy78t67gvjbhu89y78tgu909iuygcvbnjmkhuyghbvnkjiougyhbvjnmkloipughbj").toString()
            };
        }
        let response = await (0,_api_services_js_cart__WEBPACK_IMPORTED_MODULE_4__/* .removeItemFromCart */ .Cn)(obj);
        if (response === null || response === void 0 ? void 0 : response.message) {
            sweetalert__WEBPACK_IMPORTED_MODULE_6___default()(response === null || response === void 0 ? void 0 : response.message);
        } else {
            setCartData(response.data.removeItemFromCart.cart);
            localStorage.setItem("CartData", JSON.stringify(response.data.removeItemFromCart.cart));
            sweetalert__WEBPACK_IMPORTED_MODULE_6___default()("".concat(e.product.name, " removed from your cart"));
            const storageChangeEvent = new CustomEvent("localCartChanged", {
                detail: {
                    key: "CartData",
                    newValue: ""
                }
            });
            //  window.dispatchEvent(new Event('storage'));
            window.dispatchEvent(storageChangeEvent);
        }
    };
    const callUpdateCart = async ()=>{
        let tempvar = false;
        let arr = cartData.items.map((cur)=>{
            if (cur.prices.price.value == 0 && cur.quantity > 1) {
                tempvar = true;
            }
            return {
                cart_item_uid: cur.uid,
                quantity: cur.quantity ? cur.prices.price.value == 0 && cur.quantity ? 1 : cur.quantity : 1
            };
        });
        if (tempvar) {
            sweetalert__WEBPACK_IMPORTED_MODULE_6___default()("You can't order more than 1 quantity for sample");
            return;
        }
        let obj = {
            cartId: localStorage.getItem("cartId"),
            cartItems: arr
        };
        if (localStorage.getItem("userToken")) {
            obj = {
                ...obj,
                token: crypto_js__WEBPACK_IMPORTED_MODULE_8__.AES.decrypt(localStorage.getItem("userToken"), "wqeetdrcgfyt6rfychgvhy78t67gvjbhu89y78tgu909iuygcvbnjmkhuyghbvnkjiougyhbvjnmkloipughbj").toString()
            };
        }
        let response = await (0,_api_services_js_cart__WEBPACK_IMPORTED_MODULE_4__/* .updateCart */ .xu)(obj);
        if (response === null || response === void 0 ? void 0 : response.message) {
            sweetalert__WEBPACK_IMPORTED_MODULE_6___default()(response === null || response === void 0 ? void 0 : response.message);
        } else {
            setCartData(response.data.updateCartItems.cart);
            localStorage.setItem("CartData", JSON.stringify(response.data.updateCartItems.cart));
            sweetalert__WEBPACK_IMPORTED_MODULE_6___default()("Your cart updated Succesfully");
            const storageChangeEvent = new CustomEvent("localCartChanged", {
                detail: {
                    key: "CartData",
                    newValue: ""
                }
            });
            window.dispatchEvent(storageChangeEvent);
        }
    };
    const applyCoupon = async ()=>{
        // setCartData(null);
        if (!coupon.trim()) {
            sweetalert__WEBPACK_IMPORTED_MODULE_6___default()("Please enter a valid coupon code.");
            return;
        }
        let obj = {
            cartId: localStorage.getItem("cartId"),
            couponCode: coupon
        };
        if (localStorage.getItem("userToken")) {
            obj = {
                ...obj,
                token: crypto_js__WEBPACK_IMPORTED_MODULE_8__.AES.decrypt(localStorage.getItem("userToken"), "wqeetdrcgfyt6rfychgvhy78t67gvjbhu89y78tgu909iuygcvbnjmkhuyghbvnkjiougyhbvjnmkloipughbj").toString()
            };
        }
        let response = await (0,_api_services_js_cart__WEBPACK_IMPORTED_MODULE_4__/* .applyCouponToCart */ .o3)(obj);
        if (response === null || response === void 0 ? void 0 : response.message) {
            sweetalert__WEBPACK_IMPORTED_MODULE_6___default()(response === null || response === void 0 ? void 0 : response.message);
        } else {
            setCartData(response.data.applyCouponToCart.cart);
            localStorage.setItem("CartData", JSON.stringify(response.data.applyCouponToCart.cart));
            sweetalert__WEBPACK_IMPORTED_MODULE_6___default()("Coupon applied on cart.");
            const storageChangeEvent = new CustomEvent("localCartChanged", {
                detail: {
                    key: "CartData",
                    newValue: ""
                }
            });
            //  window.dispatchEvent(new Event('storage'));
            window.dispatchEvent(storageChangeEvent);
        }
    };
    const removeCoupon = async ()=>{
        let obj = {
            cartId: localStorage.getItem("cartId")
        };
        if (localStorage.getItem("userToken")) {
            obj = {
                ...obj,
                token: crypto_js__WEBPACK_IMPORTED_MODULE_8__.AES.decrypt(localStorage.getItem("userToken"), "wqeetdrcgfyt6rfychgvhy78t67gvjbhu89y78tgu909iuygcvbnjmkhuyghbvnkjiougyhbvjnmkloipughbj").toString()
            };
        }
        let response = await (0,_api_services_js_cart__WEBPACK_IMPORTED_MODULE_4__/* .removeCouponFromCart */ .r$)(obj);
        if (response === null || response === void 0 ? void 0 : response.message) {
            sweetalert__WEBPACK_IMPORTED_MODULE_6___default()(response === null || response === void 0 ? void 0 : response.message);
        } else {
            setCartData(response.data.removeCouponFromCart.cart);
            localStorage.setItem("CartData", JSON.stringify(response.data.removeCouponFromCart.cart));
            sweetalert__WEBPACK_IMPORTED_MODULE_6___default()("Coupon removed from the cart.");
            const storageChangeEvent = new CustomEvent("localCartChanged", {
                detail: {
                    key: "CartData",
                    newValue: ""
                }
            });
            //  window.dispatchEvent(new Event('storage'));
            window.dispatchEvent(storageChangeEvent);
            setCoupon("");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Orientbell Tiles - Shopping Cart Overview"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: "Orientbell Tiles - Shopping Cart Overview"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Review your chosen tiles in the Orientbell cart. Update quantities, view item details, and get closer to completing your tile purchase for your project."
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "checkout_cart_page",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "Shopping Cart"
                            })
                        }),
                        !cartData || (cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.length) == 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "shopping_cart_noitem",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "You have no items in your shopping cart."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "Click ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "#",
                                            children: "here"
                                        }),
                                        " to continue shopping."
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "shopping_cart",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "shopping_cart_data_right",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: "Summary"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "summary_data_cart",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        "Subtotal",
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            children: [
                                                                "₹ ",
                                                                cartData.prices.subtotal_including_tax.value
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                cartData.shipping_addresses && ((ref1 = cartData.shipping_addresses) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && cartData.shipping_addresses[0].selected_shipping_method && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        "Shipping (",
                                                        cartData.shipping_addresses[0].selected_shipping_method.carrier_title,
                                                        ")",
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            children: [
                                                                "₹",
                                                                " ",
                                                                cartData.shipping_addresses[0].selected_shipping_method.amount.value
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        cartData.prices.discount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "summary_data_cart",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "Discount",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        children: [
                                                            "₹ ",
                                                            cartData.prices.discount.amount.value
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "summary_data_cart",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    "Order Total",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        children: [
                                                            "₹ ",
                                                            cartData.prices.grand_total.value
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                                eventKey: "0",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Header */ .Z.Header, {
                                                        children: "Apply Discount Code"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Body */ .Z.Body, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                            onSubmit: (e)=>{
                                                                e.preventDefault();
                                                                applyCoupon();
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Group */ .Z.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "formBasicEmail",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Label */ .Z.Label, {
                                                                            children: "Enter discount code"
                                                                        }),
                                                                        (cartData === null || cartData === void 0 ? void 0 : cartData.applied_coupons) && ((ref2 = cartData === null || cartData === void 0 ? void 0 : cartData.applied_coupons[0]) === null || ref2 === void 0 ? void 0 : ref2.code) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                                                            type: "text",
                                                                            placeholder: "Enter discount code",
                                                                            value: (ref3 = cartData.applied_coupons[0]) === null || ref3 === void 0 ? void 0 : ref3.code
                                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Control */ .Z.Control, {
                                                                            type: "text",
                                                                            value: coupon,
                                                                            placeholder: "Enter discount code",
                                                                            onChange: (e)=>setCoupon(e.target.value)
                                                                        })
                                                                    ]
                                                                }),
                                                                (cartData === null || cartData === void 0 ? void 0 : cartData.applied_coupons) && ((ref4 = cartData === null || cartData === void 0 ? void 0 : cartData.applied_coupons[0]) === null || ref4 === void 0 ? void 0 : ref4.code) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                                    variant: "outline-primary",
                                                                    onClick: ()=>{
                                                                        removeCoupon();
                                                                    },
                                                                    children: "Remove Coupon"
                                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                                    variant: "outline-primary",
                                                                    type: "submit",
                                                                    value: coupon,
                                                                    onClick: ()=>{
                                                                        applyCoupon();
                                                                    },
                                                                    children: "Apply Discount"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            variant: "primary",
                                            type: "submit",
                                            onClick: ()=>{
                                                router.push("/checkout");
                                            },
                                            children: "Proceed to Checkout"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "cart_images",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "../footer-paymet2_1_1.webp",
                                                alt: "Image",
                                                style: {
                                                    width: "100%"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: "Why Orientbell Tiles ?"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: "Premium Quality products"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: "Door step delivery in 7 days (50% orders delivered in 7 days)"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: "100% refund if not happy with delivery date"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: "Assisted order processing"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: "5 samples for Rs.500/-"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: "Delivery from nearest Orientbell store"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "shopping_cart_data_left",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Table__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            responsive: true,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                        className: "thead_th",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                children: "Item"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                children: "Price"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                children: "Qty"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                children: "Subtotal"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                ((ref5 = cartData.items) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 && (cartData === null || cartData === void 0 ? void 0 : (ref6 = cartData.items) === null || ref6 === void 0 ? void 0 : ref6.map((obj, index)=>{
                                                    var ref, ref1, ref2;
                                                    let subTotal = obj === null || obj === void 0 ? void 0 : (ref = obj.prices) === null || ref === void 0 ? void 0 : ref.row_total.value;
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                                                        className: "tbody_th",
                                                        id: obj.product.sku,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                                    className: "tbody_th_item_img",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: "item"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "item_data_cart",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                    src: obj.product.image.url,
                                                                                    alt: "image"
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                                    href: "#",
                                                                                    children: obj.product.name
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                                    className: "tbody_th_item",
                                                                    style: {
                                                                        marginLeft: "0"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: "Price"
                                                                        }),
                                                                        " ",
                                                                        obj === null || obj === void 0 ? void 0 : (ref1 = obj.prices) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.price) === null || ref2 === void 0 ? void 0 : ref2.value
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                                    className: "tbody_th_item",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: "Quantity"
                                                                        }),
                                                                        " ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                            type: "number",
                                                                            value: obj.quantity,
                                                                            style: {
                                                                                width: "40px",
                                                                                textAlign: "center"
                                                                            },
                                                                            onChange: (e)=>{
                                                                                setCartData({
                                                                                    ...cartData,
                                                                                    items: cartData.items.map((cur, i)=>{
                                                                                        if (index == i) {
                                                                                            return {
                                                                                                ...cur,
                                                                                                quantity: e.target.value
                                                                                            };
                                                                                        } else {
                                                                                            return cur;
                                                                                        }
                                                                                    })
                                                                                });
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                                    className: "tbody_th_item",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            children: "Subtotal"
                                                                        }),
                                                                        " ₹ ",
                                                                        subTotal
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                    className: "tbody_th_item",
                                                                    onClick: ()=>removeFromCart(obj),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_13__/* .FaTrashAlt */ .AMf, {
                                                                        className: "deleteICon"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, index);
                                                }))
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "cont_shopping_btn",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    href: "/",
                                                    className: "btn btn-outline-primary",
                                                    children: [
                                                        " ",
                                                        "Continue Shopping"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    onClick: callUpdateCart,
                                                    variant: "outline-primary",
                                                    children: [
                                                        " ",
                                                        "Update Shopping Cart"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            variant: "primary",
                            onClick: handleGoBack,
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "../orientbell_web_flowchart_1.webp",
                            alt: "image",
                            style: {
                                width: "100%",
                                marginTop: "30px"
                            }
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Cart);


/***/ }),

/***/ 42480:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,7361,4585,7615,5063,6737,4471,5873,9774,2888,179], function() { return __webpack_exec__(68868); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);